import { observer } from 'mobx-react-lite'

import { TimingPopover } from '#components/EditorToolbar/TimingPopover/TimingPopover'
import { ButtonMode, ILoadedScript } from '#state/types'

type ScriptTimingPopoverProps = {
  script: ILoadedScript
  mode: ButtonMode
  height: number
}

export const ScriptTimingPopover = observer(function ScriptTimingPopover({
  script,
  mode,
  height,
}: ScriptTimingPopoverProps) {
  const docTiming = script.pmEditor.docTiming
  const selectionTiming = script.pmEditor.getSelectionTiming(script.readRate)

  if (!docTiming) return null

  return (
    <TimingPopover
      mode={mode}
      docTiming={docTiming}
      selectionTiming={selectionTiming}
      height={height}
    />
  )
})
